import { View } from './view'

export const TabLoan = View
